import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { map, of, type Observable } from 'rxjs';
import { ComplianceRequestsService } from '@/core/compliance/compliance-requests.service';

/**
 * Preloads the current user's pending compliance requests into ComplianceRequestsService
 * before any authenticated route renders. The dialog in AppLayout reads the resulting
 * signal and blocks interaction until all pending requests are completed.
 */
export const complianceRequestsGuard: CanActivateFn = (): Observable<boolean> => {
    const complianceRequestsService = inject(ComplianceRequestsService);

    if (complianceRequestsService.pendingRequests().length > 0) {
        return of(true);
    }

    return complianceRequestsService.loadPendingRequests().pipe(map(() => true));
};
